<template>
  <div class="col-md-3 service-card">
    <a
      :href="link_url"
      v-if="link_btn_type == 'link' && is_extern_link"
      target="_blank"
    >
      <h3>{{ title }}</h3>
      <p class="text-muted" v-if="!isNull(description)">
        {{ description }}
      </p>

      <div class="service-card-bottom">
        <button class="btn btn-secondary ripple">
          <span class="float-left text-truncate">{{ button_title }}</span>
          <i class="mdi mdi-arrow-right float-right"></i>
        </button>
      </div>
    </a>

    <div @click="action" v-if="this.link_btn_type != 'link'">
      <h3 class="text-truncate">{{ title }}</h3>
      <p class="text-muted" v-if="!isNull(description)">
        {{ description }}
      </p>

      <div class="service-card-bottom">
        <button class="btn btn-secondary ripple">
          <span class="float-left">{{ button_title }}</span>
          <i class="mdi mdi-arrow-right float-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "title",
    "description",
    "button",
    "link_type",
    "url",
    "extern_link",
    "modal_id",
  ],
  components: {},
  name: "ServiceCard",
  data: function () {
    return {
      button_title: this.button,
      link_btn_type: this.link_type,
      is_extern_link: this.extern_link,
      link_url: this.url,
      modal: this.modal_id,
    };
  },
  methods: {
    action: function (event) {
      var self = this;
      setTimeout(() => {
        if (self.link_type == "fn") {
          self[self.modal]();
        } else {
          if (self.modal.includes("_sidebar")) {
            self.toggle_sidebar(self.modal);
          } else {
            self.open_modal(self.modal);
          }
        }
      }, 100);
    },
  },
  created: async function () {
    if (_.isUndefined(this.modal_id)) {
      this.modal = "";
    }

    if (_.isUndefined(this.url)) {
      this.link_url = false;
    }

    if (this.url == "") {
      this.link_url = false;
    }

    if (_.isUndefined(this.link_type)) {
      this.link_btn_type = "link";
    }
    if (_.isUndefined(this.button)) {
      this.button_title = "Afficher";
    }

    if (_.isUndefined(this.extern_link)) {
      this.is_extern_link = false;
    }
  },
};
</script>
<style scoped lang="css">
</style>
